import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { StaffRoleWithRoleProfileFragmentDoc } from '../../fragments/generated/StaffRoleWithRoleProfile';
import { StaffRoleFragmentDoc } from '../../fragments/generated/StaffRole';
import { StaffRoleProfileFragmentDoc } from '../../fragments/generated/StaffRoleProfile';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type StaffRolesWithRoleProfileQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.RolesFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type StaffRolesWithRoleProfileQuery = { staffRoles?: { success: boolean, totalCount: number, errorCode?: Types.PaginationErrorCodeEnum | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, description?: string | null, type: Types.RoleTypesEnum, roleProfile: { usersCount: number, sampleUsers: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> }, metadata?: { tagColor?: string | null, configuredPermissions?: Array<string> | null } | null } }> | null } | null };


export const StaffRolesWithRoleProfileDocument = /*#__PURE__*/ gql`
    query staffRolesWithRoleProfile($filters: RolesFilters, $sort: [SortType!], $first: Float, $after: String) {
  staffRoles(filters: $filters, sort: $sort, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    success
    totalCount
    errorCode
    edges {
      node {
        ...StaffRoleWithRoleProfile
      }
    }
  }
}
    ${StaffRoleWithRoleProfileFragmentDoc}
${StaffRoleFragmentDoc}
${StaffRoleProfileFragmentDoc}
${UserFragmentDoc}`;

export function useStaffRolesWithRoleProfileQuery(options?: Omit<Urql.UseQueryArgs<StaffRolesWithRoleProfileQueryVariables>, 'query'>) {
  return Urql.useQuery<StaffRolesWithRoleProfileQuery, StaffRolesWithRoleProfileQueryVariables>({ query: StaffRolesWithRoleProfileDocument, ...options });
};